import React from 'react';
import { ImageSlot } from './ImageSlot';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section id="bonos" className="bg-night-panel" data-id="element-18" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" style={{
      paddingTop: "35px"
    }} data-id="element-19" data-mp="av35grzs930m">
        <div className="mx-auto max-w-2xl text-center" data-id="element-20" data-mp="ftwkwpymr43f">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-21" data-mp="fsbqr1g89n63">
            Incluidos hoy, sin costo extra
          </p>
          <h2 className="mt-3 font-display text-[2rem] font-semibold leading-tight tracking-tight text-parchment sm:text-[2.5rem]" style={{
          fontSize: "36px",
          fontWeight: "700"
        }} data-id="element-22" data-mp="5wi60uscund8">
            4 bonos de regalo
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-23" data-mp="3t180tofc683c">
            Recursos para que tu Botiquín Espiritual se convierta en un momento diario con Dios.
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-24" data-mp="1r8jtp3zkn0ia">
          {bonuses.map(bonus => <article key={bonus.title} className="flex gap-4 rounded-2xl border border-gold-soft/30 bg-night p-5 sm:gap-6 sm:p-6" data-id="element-25" data-mp="3icvdrgg4qs41">
              <ImageSlot src={bonus.image} alt={`Portada de ${bonus.title}`} label={bonus.label} className="w-24 flex-none sm:w-36" imgClassName="h-auto w-full object-contain drop-shadow-[0_14px_18px_rgba(0,0,0,0.5)]" placeholderClassName="aspect-[3/4] !rounded-lg" data-id="element-26" data-mp="3ddiqwvp9dl1g" />

              <div className="flex flex-1 flex-col" data-id="element-27" data-mp="2zg3x7erz2r3o">
                <span className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-28" data-mp="2ugr3ca2oojrl">
                  {bonus.label}
                </span>
                <h3 className="mt-1.5 font-display text-lg font-semibold leading-snug text-parchment sm:text-xl" data-id="element-29" data-mp="38e5v3lget3mq">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 font-sans text-sm font-medium italic text-gold-soft" data-id="element-30" data-mp="noq7ezchlv1b">
                  {bonus.subtitle}
                </p>
                <p className="mt-2 font-sans text-[0.95rem] leading-relaxed text-parchment/70" data-id="element-31" data-mp="3ciwrkqsxfljo">
                  {bonus.description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}